/**
 * @author Jorge Casas
 * @creationDate 03/07/2024
 */

import { createCanvas, loadImage } from 'canvas';
import { requestDownloadFileToConverBase64 } from '../../containers/assets/actions.js';

/**
 * @function generateCombinedImage
 *
 * @description Function to generate a combined PNG image from QR and Barcode URLs
 *
 * @param {string} qrUrl - The URL of the QR code image
 * @param {string} barcodeUrl - The URL of the Barcode image
 * @param {string} assetNumber - Asset number or filename for download
 * @returns {Promise<void>} - No direct return, initiates download of combined image
 * @throws {Error} - If there's an error generating the combined image
 */
export const generateCombinedImage = async (qrUrl, barcodeUrl, assetNumber) => {
  try {
    const qrBase64 = await requestDownloadFileToConverBase64(qrUrl).payload;
    const barcodeBase64 = await requestDownloadFileToConverBase64(barcodeUrl).payload;

    const qrImage = await loadImage(`data:image/jpeg;base64,${qrBase64}`);
    const barcodeImage = await loadImage(`data:image/jpeg;base64,${barcodeBase64}`);

    const canvasWidth = Math.max(qrImage.width, barcodeImage.width);
    const canvasHeight = qrImage.height + barcodeImage.height + 60;

    const canvas = createCanvas(canvasWidth, canvasHeight);
    const ctx = canvas.getContext('2d');

    const qrX = (canvasWidth - qrImage.width) / 2;
    ctx.drawImage(qrImage, qrX, 0, qrImage.width, qrImage.height);

    const barcodeScale = 0.5;
    const scaledBarcodeWidth = barcodeImage.width * barcodeScale;
    const scaledBarcodeHeight = barcodeImage.height * barcodeScale;

    const barcodeX = (canvasWidth - scaledBarcodeWidth) / 2;
    const barcodeY = qrImage.height + 60;
    ctx.drawImage(barcodeImage, barcodeX, barcodeY, scaledBarcodeWidth, scaledBarcodeHeight);

    const combinedImageBase64 = canvas.toDataURL('image/png');

    const downloadLink = document.createElement('a');
    downloadLink.href = combinedImageBase64;
    downloadLink.download = assetNumber;

    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  } catch (error) {
    console.error('Error generating combined image:', error);
    throw new Error('Error generating combined image');
  }
};



// WEBPACK FOOTER //
// src/lib/images/AssetsCodesLabel.js